import * as AT from '../constants/actionTypes'

/**
 * City reducer
 * @param {*} state 
 * @param {*} action 
 */
function city(state = { cities: [], citiesWithPostalCode: [], cityZipData: [], isCityZipDataLoaded: false }, action) {
	switch (action.type) {
		case AT.CITY_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				cities: [],
				citiesWithPostalCode: [],
				error: undefined
			})
		case AT.CITY_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.CITY_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				cities: action.payload.cities,
				error: undefined
			})
		case AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				citiesWithPostalCode: [],
				error: undefined
			})
		case AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				citiesWithPostalCode: [],
				error: action.payload.error
			})
		case AT.CITY_WITH_POSTAL_CODE_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				citiesWithPostalCode: action.payload.cities,
				error: undefined
			})
		case AT.CITY_ZIP_DATA_LOADING_STARTED:
			return Object.assign({}, state, {
				isCityZipDataLoading: true,
				error: undefined
			})
		case AT.CITY_ZIP_DATA_LOADING_FAILED:
			return Object.assign({}, state, {
				isCityZipDataLoading: false,
				error: action.payload.error
			})
		case AT.CITY_ZIP_DATA_LOADING_FINISHED:
			return Object.assign({}, state, {
				isCityZipDataLoading: false,
				cityZipData: action.payload.cityZipData,
				isCityZipDataLoaded: true,
				error: undefined
			})
		default:
			return state;
	}
}

export default city;